import { getChartLabel } from "./chartLabel";
import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";
import EvthLegend from "./EvthsLegend";

const Evths6 = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: "place", // default sort by place
    direction: "asc",
  });

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const pwtestData = data.map((item) => ({
    place: item.Place,
    vl_tested: Number(item.vl_tested),
    vl_suppressed: Number(item.vl_suppressed),
  }));

  const legendOrder = [
    "Viral Load tests conducted for HIV positive Pregnant Women",
    "HIV positive pregnant women on ART who are virally suppressed",
  ];

  // Sorting logic
  const sortedData = [...pwtestData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Handle sorting click
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  // Icon display function
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⬍"; // default icon
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
    if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(pwtestData.length);
  const chunkedData = chunkArray(pwtestData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* Toggle Switch */}
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5>
                {" "}
                PPW VL Tested and Virally Suppressed{" "}
                {getChartLabel(filters, selectedState)}
              </h5>
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>

      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>

                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("vl_tested")}
                  >
                    Viral load tests conducted for HIV positive Pregnant Women
                    {getSortIcon("vl_tested")}
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("vl_suppressed")}
                  >
                    HIV positive pregnant women on ART who are virally
                    suppressed
                    {getSortIcon("vl_suppressed")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold" style={{ fontWeight: "bold" }}>
                      {item.place}
                    </td>

                    <td>{item.vl_tested}</td>
                    <td>{item.vl_suppressed}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View
        <>
          {chunkedData.map((chunk, index) => (
            <div key={index} className="card hptCard mt-4 border-0">
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                  />
                  <YAxis />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" content={<CustomLegend />} />
                  {/* <Bar
                  dataKey="PW_tested_hiv"
                  fill="#dc3545"
                  name="PW Screened for Syphilis"
                >
                  <LabelList dataKey="syphilis_screened" position="top" />
                </Bar> */}
                  <Bar
                    dataKey="vl_tested"
                    fill="#dc3545"
                    name="Viral Load tests conducted for HIV positive Pregnant Women "
                  >
                    <LabelList
                      dataKey="vl_tested"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    dataKey="vl_suppressed"
                    fill="#00a084"
                    name="HIV positive pregnant women on ART who are virally suppressed"
                  >
                    <LabelList
                      dataKey="vl_suppressed"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Evths6;
